import InstanceApi from "@/services/apiClient.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      paimentMethods: {},
      reinsurance: "",
      choice: "",
    };
  },

  computed: {
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
  },

  mounted() {
    this.getAvailablePaimentMethods();
  },

  methods: {
    async getAvailablePaimentMethods() {
      try {
        const availablePaimentUrl = "mcp/checkout/payment";
        const response = await InstanceApi.post(availablePaimentUrl);

        if(response.data.methods) {
          this.paimentMethods = response.data.methods;
          this.reinsurance = response.data.reinsurance;
          let choiceIndex = 0;
          
          try {
            const devider = parseInt(localStorage.getItem("devider"));
            if (devider) {
              choiceIndex = devider - 1;
            }
          } catch (error) {
            console.error(error);
          }
          
          this.choice = response.data.methods[choiceIndex].code;
          this.$store.dispatch("setPaymentMethods", this.paimentMethods);
          this.$store.dispatch("setHostedFields", response.data.hosted_fields);
        }
      } catch (error) {
        console.log('ERROR', error);
        window.location.replace(process.env.VUE_APP_API_BASE_URL+this.storeUrlPrefix);
      }
    },
  },
  watch: {
    choice() {
      const choosenMethod = this.paimentMethods
        ? this.paimentMethods.find(e => e.code === this.choice)
        : {};
      this.$store.dispatch("setChoosenPaymentMethod", choosenMethod);
    },
  },
};
